// extracted by mini-css-extract-plugin
export default {"root":"B5gSJ","createPostButton":"ZT51z"};